<ng-container *transloco="let t">
  <div class="result-trio-dog" [formGroup]="form">
    <div class="field">
      <label class="label">{{ t('trio.cpv') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="cpv" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('trio.ccv') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="ccv" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('trio.giardia') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="giardia" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('trio.note') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea
          matInput
          formControlName="note"
          rows="6"
          placeholder="{{ t('Additional notes') }}"
        ></textarea>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput formControlName="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
